import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-pin-button, button[app-pin-button]',
  templateUrl: './pin-button.component.html',
  styleUrls: ['./pin-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PinButtonComponent implements OnInit {
  @Input()
  icon: string;

  @Input()
  src: string;

  @Input()
  description: string;

  @Input()
  label: string;

  @Input()
  selectable = false;

  @Input()
  size: 'small' | 'medium' | 'large' = 'medium';

  @Input()
  buttonType: 'default' | 'ghost' | 'outline' | 'floating' | 'dark' | 'primary' | 'secondary' = 'default';

  @Input()
  direction: 'row' | 'column' = 'column';

  @Input()
  fill = false;

  @Input()
  public get selected() {
    return this._selected;
  }
  public set selected(value) {
    this._selected = value;
    this.selectedChange = new EventEmitter<boolean>();
  }
  private _selected = false;

  @Input()
  disabled = false;

  @Output()
  selectedChange = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  handleClick() {
    if (this.disabled) {
      return;
    }

    if (this.selectable) {
      this.selected = !this.selected;
    }
  }
}
